import { get } from 'svelte/store';
import { cloud, paypal, paypalTest } from 'src/services/http';
import { navigateToUrl } from 'src/components/Lists/list-helpers';
import { applicationHostUrl } from './account_helpers';
import { app } from 'src/stores/session/native-bridge';
import { isDevServerUser } from 'src/helpers/user_server_conditions';
export const getUserInfo = async () => {
	const res = await cloud.get('/user/info');
	if (res.isok) {
		return res.data;
	}
};

export interface UnsubscribeSuccessResponse {
	premium: number;
}
export interface UnsubscribeErrorResponse {
	error: string;
}
export type UnsubscribeResponse = UnsubscribeSuccessResponse | UnsubscribeErrorResponse;

export const unsubscribe = async (): Promise<UnsubscribeResponse> => {
	const client = isDevServerUser(['repo', 'nb']) ? paypalTest : paypal;
	const res = await client.post('/api/unsubscribe');
	return (res as { data: UnsubscribeResponse }).data;
};

export interface SubscribeSuccessResponse {
	subscription_id: string;
	link: string;
}
export interface SubscribeErrorResponse {
	error?: string;
	error_code?: number | string;
	trace?: string;
}
export type SubscribeResponse = SubscribeSuccessResponse | SubscribeErrorResponse;

export const subscribe = async (type: number): Promise<{ data: SubscribeResponse }> => {
	let res: { data: SubscribeResponse };
	const route = '/#/settings/premium';
	const redirectUrl = applicationHostUrl(
		import.meta.env.VITE_APP_BUCKET || window.location.host,
		route,
	);

	if (isDevServerUser(['repo', 'nb'])) {
		res = (await paypalTest.post(
			`/api/subscribe/${type}`,
			{},
			{ headers: { 'x-shelly-redirect': redirectUrl } },
		)) as { data: SubscribeResponse };
	} else {
		res = (await paypal.post(
			`/api/subscribe/${type}`,
			{},
			{ headers: { 'x-shelly-redirect': redirectUrl } },
		)) as {
			data: SubscribeResponse;
		};
	}

	if (res?.data && 'link' in res.data && res.data?.link) {
		get(app) ? navigateToUrl(res.data.link) : (window.location.href = res.data.link);
	}
	return res;
};
